/**
 * Парсит размер файла из строки (например "10 MB", "50 MB", "1 KB").
 * Возвращает размер в байтах или 0 при ошибке.
 */
export function parseFileSizeToBytes(str: string): number {
  const trimmed = str.trim().toUpperCase();
  const match = trimmed.match(/^(\d+(?:\.\d+)?)\s*(B|KB|MB|GB)?$/);
  if (!match) {
    return 0;
  }
  const value = parseFloat(match[1]);
  const unit = match[2] ?? 'B';
  const multipliers: Record<string, number> = {
    B: 1,
    KB: 1024,
    MB: 1024 * 1024,
    GB: 1024 * 1024 * 1024,
  };

  return Math.floor(value * (multipliers[unit] ?? 1));
}
